import TariffSetConnectionLimits from './TariffSetConnectionLimits';

export default TariffSetConnectionLimits;
